// Endereço da API — UMA fonte para todos os clientes (inboxApi, orgsApi, appointmentsApi).
//
// Em módulo próprio, e não dentro do inboxApi, porque o inboxApi reexporta o orgsApi: se o
// orgsApi importasse a base do inboxApi, o import seria circular (e quebra nos testes).
const isBrowser = typeof window !== "undefined";
const isTest = process.env.NODE_ENV === "test";
const fromEnvCRA = process.env.REACT_APP_API_BASE_URL;
const fromGlobal = isBrowser ? window.__API_BASE_URL__ : undefined;

// Em dev/produção sem variável, usamos '/api'.
// Em testes, apontamos para http://localhost:4000.
const rawApiBase = fromEnvCRA || fromGlobal || (isTest ? "http://localhost:4000" : "/api");

// sempre sem barra final
export const API_BASE_URL = String(rawApiBase || "/api").replace(/\/+$/, "");

/** A base terminando em /api — para clientes que montam "/api/..." por conta própria. */
export function baseComApi() {
  return API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;
}
